import { MigrationReadinessReport } from 'types/MigrationReadinessReport';
import API, { AxiosRequestOptions } from './API';

export const getMigrationReadinessReport = async (
  options?: AxiosRequestOptions,
): Promise<MigrationReadinessReport> => {
  const response = await API.get<MigrationReadinessReport>(
    '/api/v2/migration-readiness-report',
    options,
  );
  return response.data;
};
